import { render, staticRenderFns } from "./ContentBody.vue?vue&type=template&id=de3620f2&scoped=true"
import script from "./ContentBody.vue?vue&type=script&lang=js"
export * from "./ContentBody.vue?vue&type=script&lang=js"
import style0 from "./ContentBody.vue?vue&type=style&index=0&id=de3620f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de3620f2",
  null
  
)

export default component.exports